import React, { useState } from "react";
import { Box, Button, Typography, TextField, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

const FeedBackPopup = ({ open, onClose, onSubmit }: { open: boolean; onClose: () => void; onSubmit: (feedback: { type: string; message: string }) => void }) => {
  const [feedbackType, setFeedbackType] = useState<string>("");
  const [message, setMessage] = useState<string>("");

  const handleFeedbackType = (type: string) => {
    setFeedbackType(type);
  };

  const handleSubmit = () => {
    if (feedbackType && message) {
      onSubmit({ type: feedbackType, message });
      setFeedbackType("");
      setMessage("");
      onClose();
    } else {
      alert("Please select feedback type and enter a message.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{background:"#4f758b", color: "#fff", textAlign:"center"}}>Give Us Your Feedback</DialogTitle>
      <DialogContent sx={{paddingTop: "20px", paddingBottom: "20px"}}>
        <Typography variant="subtitle1" gutterBottom>
          Select Feedback Type:
        </Typography>
        <Box display="flex" gap={2} mb={2}>
          <Button
            variant={feedbackType === "Partially Wrong" ? "contained" : "outlined"}
            onClick={() => handleFeedbackType("Partially Wrong")}
          >
            Partially Wrong
          </Button>
          <Button
            variant={feedbackType === "Fully Wrong" ? "contained" : "outlined"}
            onClick={() => handleFeedbackType("Fully Wrong")}
          >
            Fully Wrong
          </Button>
          <Button
            variant={feedbackType === "Other" ? "contained" : "outlined"}
            onClick={() => handleFeedbackType("Other")}
          >
            Other
          </Button>
        </Box>
        <Typography variant="subtitle1" gutterBottom>
          Add Your Message:
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          placeholder="Enter your feedback here..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </DialogContent>
      <DialogActions sx={{display: "flex", justifyContent: "center", padding: "10px"}}>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedBackPopup;